module.exports = __webpack_public_path__ + "img/hubspot-logo.9a2ca65c.png";